// 海外信息
export default {
  namespaced: true,
  state: {
    isOversea: false, // 非海外用户
    overseaInfo: {}, // 海外ip信息
  },
  mutations: {
    setOversea(state, info) {
      state.isOversea = info;
    },
    setOverseaInfo(state, info) {
      state.overseaInfo = info;
    },
  },
};
